<template>
  <div class="aboveallhtml">
    <div class="aboveallmid">
      <div class="aboveallhead">
        <transition name="flip-list" mode="out-in">
          <div
            :style="{
              background: 'url(https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=26) no-repeat center',
            }"
            :src="imagesrc[imgindex]"
            :key="imagesrc[imgindex]"
            class="imgsrc"
            id="imgsrc"
            ref="imgsrc"
          ></div>
        </transition>
        <!-- <img src="../../assets/images/banner.jpg" alt=""> -->
      </div>
      <div class="aboveallbody">
        <div class="bodymid">
          <div v-for="(item,index) in homeList" :key="index" class="home_mid_item">
            <div class="mid_item_title"><img :src=item.title alt=""></div>
            <div class="mid_item_text">{{item.text}}</div>
            <div class="flex_item">
              <div v-for="(item1,index1) in  item.list" :key="index1" class="mid_item_items" @click="gotoP(item.url,item1.url)">
                <img :src=item1.img alt="">
                <div class="items_box" :style="{background: 'url('+item1.img+') no-repeat center/cover'}">
                  <div :class="item1.class" class="items_box_text">
                    <div class="title_img">{{item1.title}}</div>
                    <div class="text_img" v-if="item1.text">{{item1.text}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>

      <div class="home_bottom">
        <div class="bottom_item">
          <div class="bottom_title"><common-data name="appShortName_12"/><common-data name="appFullName_12"/></div>
          <div class="bottom_text">
            <div class="bottom_text">
              <!-- <p class="righttext">
                文华财经旗下的一款收费的高端行情交易软件，针对机构和专业投资者，提供一机多屏、F9商品深度资料、指标预警、趋势线预警，以及可以选配的多账号一带多下单、套利交易、国内五档行情数据、外盘行情数据...
              </p> -->
              <ResTxt  id="7a18cbda86053"  />
              <div class="aquestion">
                <img src="../../assets/images/wenh.png" />
                <div
                  style="
                    letter-spacing: 1px;
                    position: relative;
                    bottom: 4px;
                    display: inline-block;
                    margin-left: 5px;
                  "
                >
                  <a
                    style="color: #304560; font-size: 12px"
                    target="_blank"
                    href="https://pay.wenhua.com.cn/#/question"
                  >
                    购买相关常见问题</a
                  >
                </div>
              </div>
              <div class="aquestion" style="margin-left: 68px; font-size: 12px">
                <img src="../../assets/images/PT-01.png" />
                <div
                  style="
                    letter-spacing: 1px;
                    position: relative;
                    bottom: 4px;
                    display: inline-block;
                    margin-left: 3px;
                  "
                >
                  <common-data name="appShortName_12"/>配套系统－文华<common-data name="appFullName_TMS"/>
                  <a
                    style="color: #304560; margin-left: 2px"
                    target="_blank"
                    href="https://tms.wenhua.com.cn/#/home"
                  >
                    去进一步了解</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <wh7footer></wh7footer>
  </div>
</template>

<script>
import wh7footer from "./components/wh7/wh7footer.vue";
import ResTxt from "@/ResData/ResTxt";
import commonData from '../../plugin/FetchCommonData/'
export default {
  components: {
    wh7footer,
    ResTxt,
  },
  data() {
    return {
      yjdp: false,

      activeName: "first",
      imgindex: 0,
      imagesrc: [require("../../assets/images/banner.jpg")],
      test: {},
      timeset: null,
      homeList:[
        {
          title:require("../../assets/images/a.png"),
          text:'引用产业大数据、宏观数据做价格研究',
          url:'/productcenterjgyj',
          list:[
            {
              img:require("../../assets/images/1-3.png"),
              title:'小文研报',
              url:'/xwyb',
              class:'mid1_1 mid1_13',
              text:'',
              // text:'采用大模型技术，依托文华财经'+this.$store.state.commonDataObj.companyAge+'年积累的大型语料库，7*24小时、随时提供专业的商品研究报告',
            },
            {
              img:require("../../assets/images/小文估值.png"),
              title:'小文估值',
              url:'/gzx',
              class:'mid1_1 mid1_21',
              text:'采用大模型技术， 依托文华财经的大型产业数据库，用产量、库存、现货价格、进出口、宏观面等多元数据构建估值体系，提供50个商品的估值数据',
            },
            {
              img:require("../../assets/images/1-2.png"),
              title:'期货/期权折算估值 ',
              url:'/gljy',
              class:'mid1_1 mid1_22',
              text:'原创的期权折算价、期货折算价算法用期货和期权的关联性做交易',
            },
                        {
              img:require("../../assets/images/1-1.png"),
              title:'套利k线图',
              url:'/tltb',
              class:'mid1_1 mid1_11',
              text:'带历史年度数据的套利价差k线图、价差分布图、价差周期性、二腿相关度、二腿价格走势百分比图...',
            },
            {
              img:require("../../assets/images/五档.png"),
              title:'五档多空力量示意图 ',
              url:'/dkll',
              class:'mid1_1 mid1_12',
              text:'基于盘口五档挂单量累计数据绘制条状图，可视化展示买卖双方多空力量强弱变化',
            },
          ],
        },
        {
          title:require("../../assets/images/b.png"),
          text:'统计分析、图表、算法下单',
          url:'/productcenterzyjy',
          list:[
            {
              img:require("../../assets/images/2-1.png"),
              title:'套利交易',
              url:'/tljy',
              class:'mid1_2',
              text:'套利辅助算法交易、套利挂单交易、套利风控单、套利分批交易、多账号套利下单...',
            },
            {
              img:require("../../assets/images/2-2.png"),
              title:'移仓交易',
              url:'/ycjy',
              class:'mid1_2',
              text:'移仓价差成交量统计、移仓量\n\r指标...',
            },
            {
              img:require("../../assets/images/2-3.png"),
              title:'网格交易',
              url:'/wgjy',
              class:'mid1_2',
              text:'单向网格策略、固定网格策略',
            },
          ],
        },
        {
          title:require("../../assets/images/c.png"),
          text:'交易员的好助手',
          url:'/productcenterxgj',
          list:[
            {
              img:require("../../assets/images/3-1.png"),
              title:'多账号下单',
              url:'/dzh',
              class:'mid1_3',
              text:'一带多模式、投资经理/交易员模式',
            },
            {
              img:require("../../assets/images/3-2.png"),
              title:'算法分批下单',
              url:'/fpxd',
              class:'mid1_3',
              text:'原创“小鬼插队”算法，以及\n\r幽灵、冰山等7种经典算法',
            },
          ],
        },
      ],
    };
  },
  methods: {
    // wh7lunbo(){
    //   while(this.index<this.imagesrc.length){
    //   setInterval(function(){ this.index=this.index+1 }, 2000);

    //   console.log(this.imagesrc[this.index])
    //   }
    //   this.index=0
    //    this.wh7lunbo()
    // },
    wh7lunbo() {
      this.timer = setInterval(() => {
        this.gotoPage(this.nextIndex);
      }, 2000);
    },
    gotoPage(index) {
      this.imgindex = index;
    },
    gotoP(url,url1){
      this.$router.push('/proc'+url+url1)
    },
  },
  computed: {
    nextIndex() {
      if (this.imgindex == this.imagesrc.length - 1) {
        return 0;
      } else {
        return this.imgindex + 1;
      } //首页最上方图片轮播
    },
  },
  mounted() {
    this.wh7lunbo();
    commonData('companyAge').then(data => {
      this.homeList[0].list[0].text ='采用大模型技术，依托文华财经'+data+'年积累的大型语料库，7*24小时、随时提供专业的商品研究报告'
    })
    var ua = navigator.userAgent.toLowerCase();
    if (
      ua.match(/MicroMessenger/i) == "micromessenger" ||
      ua.match(/iphone os/i) == "iphone os" ||
      ua.match(/ipad/i) == "ipad" ||
      ua.match(/android/i) == "android" ||
      ua.match(/midp/i) == "midp" ||
      ua.match(/rv:1.2.3.4/i) == "rv:1.2.3.4" ||
      ua.match(/ucweb/i) == "ucweb" ||
      ua.match(/windows ce/i) == "windows ce" ||
      ua.match(/windows mobile/i) == "windows mobile"
    ) {
      this.$refs.imgsrc.style.width = 100 + "%";
      this.$refs.imgsrc.style.margin = 0;
    }
    //  document.getElementById("imgsrc").css("background","url("+this.imagesrc[this.imgindex]+")")
  },
};
</script>

<style>
td {
  height: 35px;
  border: 1px solid #cdcdcd;
  line-height: 35px;
  vertical-align: middle;
  font-size: 14px;
  padding-left: 40px;
  letter-spacing: 1px;
}
.aboveallhtml {
  z-index: 30;
  margin: 0 auto;
  min-width: 1400px;
  width: 100%;
  padding-top: 22px;
}
.aboveallhead {
  text-align: center;
  height: 346px;
  min-width: 1400px;
  width: 100%;
  margin: 0 auto;
}
.imgsrc {
  background: url("../../assets/images/banner.jpg") no-repeat center;
  height: 100%;
  min-width: 1400px;
  /* width:106%; 
  margin-left:-3%; */
  /* image-rendering: pixelated; */
}
.aboveallyellow {
  /* background: url("../../assets/images/about.jpg") no-repeat center;
  height: 126px; */
  background-size: auto 100%;
  min-width: 1400px;
  width: 100%;
  margin: 0 auto;
}
.aboveallbody {
  background: url("../../assets/images/ly-bg.jpg") no-repeat center;
  background-size: 100% 100%;
  /* width: 1400px; */
  width: 100%;
  margin: 0 auto;
}
.yellowright {
  float: right;
  width: 870px;
  height: 129px;
}
.yellowleft {
  float: left;

  width: 330px;
  height: 129px;
}
.yellowtext {
  width: 1200px;
  margin: 0 auto;
  height: 129px;
}
.righttext {
  width: 807px;
  font-size: 14px;
  margin-left: 50px;
  margin-top: 37px;
  line-height: 20px;
  margin-right: 0px;
  letter-spacing: 1px;
}
.aquestion {
  display: inline-block;
  margin-top: 15px;
}

.aboveallmid {
  min-width: 1400px;
  max-width: 100%;
}
.bodymid{
  width: 1039px;
  margin: 0 auto;
  /* display: flex;
  flex-direction: row;
  justify-content: space-between; */
  /* padding-top: 80px; */
  padding-bottom: 26px;
  padding-left: 10px;
}
.bdmidleft{
  margin-right: 20px;
  position: relative;
}
.flex1{
  display: flex;
  flex-direction: column;
  margin-right: 10px;
}
.flex2{
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}
.ref-wrap{
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  transition: all .4s;
}

.home_mid_item {
  padding-top: 26px;
}
.mid_item_title{
  margin-left: -2px;
}
.flex_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.mid_item_text {
  color: #252b3a;
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 16px;
}
.mid_item_items {
  cursor: pointer;
  position: relative;
  margin-right: 10px;
  margin-bottom: 15px;
}
.mid_item_items img {
  position: relative;
  z-index: -1;
}
.items_box {
  position: absolute;
  inset: 0;
  transition: all 0.3s ease-in-out;
}
.items_box_text{
  position: absolute;
}
.mid1_1{
  left: 120px;
  top: 40px;
}
.mid1_2 {
  left: 120px;
  top: 40px;
}
.mid1_3 {
  left: 120px;
  top: 40px;
}
/* .mid1_4 {
  right: 60px;
  top: 40px;
} */
.title_img{
  font-size: 18px;
  font-weight: bold;
}
.mid1_1 .title_img{
  color: #2f4b60;
}
.mid1_2 .title_img {
  color: #644610;
}
.mid1_3 .title_img {
  color: #2f4b60;
}
/* .mid1_4 .title_img {
  color: #644610;
  text-align: right;
} */
.items_box:hover{
  inset: -2%;
}
.text_img {
  font-size: 14px;
  margin-top: 16px;
  margin-right: 17px;
  line-height: 18px;
}
.mid1_1 .text_img {
  color: #575d6c;
}

.mid1_2 .text_img {
  color: #936e1d;
  white-space: break-spaces;
}
.mid1_3 .text_img {
  color: #575d6c;
  white-space: break-spaces;
}

/* .mid1_4 .text_img {
  color: #936e1d;
  text-align: right;
} */
.mid1_1 .text_img {
  color: #575d6c;
  white-space: break-spaces;
}
.mid1_11 .text_img{
  width: 200px;
  text-align: justify;
}
.mid1_12 .text_img{
  width: 200px;
  text-align: justify;
}
.mid1_13 .text_img{
  width: 200px;
  text-align: justify;
}
.mid1_21 .text_img{
  width: 210px;
  text-align: justify;
}
.mid1_22 .text_img{
  width: 160px;
  text-align: justify;
}


.home_bottom{
  background: url(../../assets/images/about_01.jpg) no-repeat center;
  margin-top:20px;
  margin-bottom: 20px;
}
.bottom_item{
  width: 890px;
  margin: 0 auto;
  padding-top: 63px;
  padding-bottom: 20px;
}
.bottom_title{
  color: #640408;
  font-size: 16px;
  margin-bottom: 16px;
  font-weight: 600;
}
.bottom_text{
  color: #6e6e6e;
  font-size: 14px;
  /* letter-spacing: 1px; */
  line-height: 25px;
  /* text-indent: 2em; */
  width: 910px;
}
</style>